export const emptyLatexValue = ['<p> <br></p>', '<p><br></p>']

export const masterTestTypes = [
    {
        dispayName: 'full',
        code: 'full',
    },
    {
        dispayName: 'unit',
        code: 'unit',
    },
    {
        dispayName: 'part',
        code: 'part',
    },
    {
        dispayName: 'Half Course',
        code: 'combined',
    },
    {
        dispayName: 'concept',
        code: 'concept',
    },
    {
        dispayName: 'sample',
        code: 'sample',
    },
    {
        dispayName: 'chap',
        code: 'chap',
    },
    {
        dispayName: 'phase',
        code: 'phase',
    }
];

export function titleCase(str: string) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}

export const praticeTestTypeCode = 'practice'

export const contentTypesForContentHistoryMap = {
    studymaterial: 'studymaterial',
    sampleproblem: 'sampleproblem',
    question: 'question',
    formulae: 'formulae',
    testpapers: 'test',
    video: 'video',
    audio: 'audio'
}

export enum QUESTION_TYPES {
    SMCQ = 0,
    MATRIX = 1,
    TRUE_FALSE = 2,
    BLANKS = 3,
    DESCRIPTIVE = 4,
    PARAGRAPH = 5,
    NUMERICAL = 6,
    INTEGER = 7,
    MMCQ = 8,
}

export const QUESTION_TYPE: any = {
     "0": 'SMCQ',
     "8": 'MMCQ',
     "2": 'True & False',
     "1": 'Matrix',
     "3": 'Blanks',
     "4": 'Descriptive',
     "7": 'Integer',
     "5": 'Paragraph',
     "6": 'Numerical',
     "9": 'Video'
}

export const QUESTION_TYPES_ARRAY = ['SMCQ', 'MATRIX', 'TRUE_FALSE', 
'BLANKS', 'DESCRIPTIVE', 'PARAGRAPH', 'NUMERICAL', 'INTEGER', 'MMCQ']

export enum CONTENT_STATES {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT'
}

export enum VIDEO_UPLOAD_MODES {
    EDIT = 'edit'
}
export enum CREATE_NOTES_TABS {
    UPLOAD_PDF = 'Upload PDF',
    TYPE_NOTES = 'Type Notes'
}
export enum NOTES_SECTION {
    CPP_SUBJECTIVE = 'cppSubjective',
    CPP_OBJECTIVE = 'cppObjective',
    WORKBOOK_SUBJECTIVE = 'workbookSubjective',
    WORKBOOK_OBJECTIVE = 'workbookObjective',
    ASSIGNMENT_SUBJECTIVE = 'assignmentsSubjective',
    ASSIGNMENT_OBJECTIVE = 'assignmentsObjective',
    ARCHIVE_SUBJECTIVE = 'archiveSubjective',
    ARCHIVE_OBJECTIVE = 'archiveObjective'
}

export const SUBJECTIVE_NOTES = [NOTES_SECTION.CPP_SUBJECTIVE, NOTES_SECTION.WORKBOOK_SUBJECTIVE, NOTES_SECTION.ASSIGNMENT_SUBJECTIVE, NOTES_SECTION.ARCHIVE_SUBJECTIVE];
export const OBJECTIVE_NOTES = [NOTES_SECTION.CPP_OBJECTIVE, NOTES_SECTION.WORKBOOK_OBJECTIVE, NOTES_SECTION.ASSIGNMENT_OBJECTIVE, NOTES_SECTION.ARCHIVE_OBJECTIVE];
export const ARCHIVE_NOTES = [NOTES_SECTION.ARCHIVE_OBJECTIVE, NOTES_SECTION.ARCHIVE_SUBJECTIVE];

export enum NOTES_TYPE {
    SUBJECTIVE_NOTES = 'SUBJECTIVE_NOTES',
    OBJECTIVE_NOTES = 'OBJECTIVE_NOTES',
    SIMPLE_NOTES = 'SIMPLE_NOTES',
    ARCHIVE = 'ARCHIVE'
}

export enum TYPE_OF_CONTENT {
    NOTES = 'Notes',
    CPP_SUBJECTIVE = 'CPP (Subjective)',
    CPP_OBJECTIVE = 'CPP (Objective)',
    WORKBOOK_SUBJECTIVE = 'Workbook (Subjective)',
    WORKBOOK_OBJECTIVE = 'Workbook (Objective)',
    ASSIGNMENT_SUBJECTIVE = 'Assignment (Subjective)',
    ASSIGNMENT_OBJECTIVE = 'Assignment (Objective)',
    ARCHIVE_SUBJECTIVE = 'Archive (Subjective)',
    ARCHIVE_OBJECTIVE = 'Archive (Objective)'
}

export enum TABLE_OF_CONTENT {
    PRACTICE_SET = 'Practice Set',
    STUDY_MATERIAL = 'Study Material',
    NOTES = 'Notes'
}
export enum AUDIO_UPLOAD_MODES {
    EDIT = 'edit'
}
export const AudioUrlImage:string = "https://mypat-v2-staging.s3.us-west-2.amazonaws.com/audios/audio-img.svg";
export const AudioThumbnailImage: string = "https://mypat-v2-staging.s3.us-west-2.amazonaws.com/audios/audio-thumbnail.png";
export const AudioUploadImage:string = "/assets/svg/audio-icon.svg";

export const ChaptersAndConceptsForContent={
    question:["concepts"],
    notes:["chapters","concepts"],
    video:["chapters","concepts"],
    audio:["chapters","concepts"]
}

export enum CONTENT_TYPE{
    NOTES='notes',
    QUESTION='question',
    VIDEO='video',
    AUDIO='audio'
}

export const USER_MANAGEMENT = {
    USERS: {
        USER_DETAILS: 'User Details',
        ROLES: 'Roles',
        STATUS: 'Status',
        CLIENTS: 'Client',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
    }
}

export const ADD_TO_QUEUE_PROPERTIES = ['subjects'];
export const FORM = {
    YES: {
        LABEL: 'Yes',
        VALUE: 'yes'
    },
    NO: {
        LABEL: 'No',
        VALUE: 'no'
    }
}

export const TESTPAPER_PROPERTY = {
    BASIC_INFO: 'basicInfo'
}
export const QUESTION_TYPE_CODE = {
    PARAGRAH: '5'
}
export const HISTORY_TYPE = {
    CHANGE_REQUEST_SUBMITTED: 'change-request-submitted',
    CHANGE_REQUEST_PUBLISHED: 'change-request-approved',
    CHANGE_REQUEST_REJECTED: 'change-request-rejected',
    CHANGES_BULK_OPERATION: 'changes-bulk-operation',
    EDITED_PUBLISHED_DIRECTLY: 'edited-published-directly',
};
export const TEST_QUESTION_CHECKBOXES = ['none', 'view', 'create', 'validate', 'edit'];

export const PERMISSION_CONTENT_TYPES = {
    GLORIFIRE_TESTPAPERS: 'test',
    FTRE_TESTPAPERS: 'ftreTest',
    AITS_TESTPAPERS: 'aitsTest',
    NATIONAL_LEVEL_TESTPAPERS: 'nationalLevelTest',
    GLORIFIRE_QUESTION: 'question',
    FTRE_QUESTION: 'ftreQuestion',
    AITS_QUESTION: 'aitsQuestion',
    NATIONAL_LEVEL_QUESTION: 'nationalLevelQuestion',
    DEFAULT_TEST_TEMPLATE: 'defaultTemplate',
    CUSTOM_TEST_TEMPLATE: 'customTemplate',
    STUDY_MATERIAL: 'studyMaterial',
    TEMPLATE_SETTINGS: 'rule',
    EDP_QUESTION_CREATE_REPORT: 'edp_report_ques_create',
    EDP_QUESTION_ISSUE_REPORT: 'edp_report_ques_issue',
}

export const AUTHORING_CONTENT_TYPES = {
    STUDY_MATERIAL: 'studymaterial',
    GLORIFIRE_TESTPAPERS: 'testpapers',
    FTRE_TESTPAPERS: 'ftreTestpapers',
    AITS_TESTPAPERS: 'aitsTestpapers',
    NATIONAL_LEVEL_TESTPAPERS: 'nationalLevelTestpapers',
    GLORIFIRE_QUESTION: 'question',
    FTRE_QUESTION: 'ftreQuestion',
    AITS_QUESTION: 'aitsQuestion',
    NATIONAL_LEVEL_QUESTION: 'nationalLevelQuestion',
}

export const AUTHORING_TEST_CONTENT_TYPES = [AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS, AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS, AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS, AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS];
export const AUTHORING_QUESTION_CONTENT_TYPES = [AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION, AUTHORING_CONTENT_TYPES.FTRE_QUESTION, AUTHORING_CONTENT_TYPES.AITS_QUESTION,AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION];

export const MODULES = {
    QUESTION_MODULES: [
        {
            NAME: PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION,
            DISPLAY_NAME: 'Glorifire',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.FTRE_QUESTION,
            DISPLAY_NAME: 'Admission Test',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.AITS_QUESTION,
            DISPLAY_NAME: 'AITS',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION,
            DISPLAY_NAME: 'National Level Test',
        },
    ],
    TEST_MODULES: [
        {
            NAME: PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS,
            DISPLAY_NAME: 'Glorifire',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS,
            DISPLAY_NAME: 'Admission Test',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS,
            DISPLAY_NAME: 'AITS',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS,
            DISPLAY_NAME: 'National Level Test',
        },
    ],
    TEMPLATE_MODULES: [
        {
            NAME: PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE,
            DISPLAY_NAME: 'Default Test Template',
        },
        {
            NAME: PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE,
            DISPLAY_NAME: 'Custom Test Template',
        }
    ],
    STUDYMATERIAL: 'studyMaterial',
    QUESTION: 'question',
    TEST: 'test',
    RULE: 'rule',
    TAG: 'tag',
    GOAL: 'goal',
    EDP: 'edp',
    USER: 'user',
    COURSE: 'course',
    SHARE: 'share',
    EDP_QUESTION_ISSUE_REPORT: 'edp_report_ques_issue',
    EDP_QUESTION_CREATE_REPORT: 'edp_report_ques_create',
};

export const USER_RIGHTS = {
    CREATE: 'create',
    EDIT: 'edit',
    VIEW: 'view',
    PUBLISH: 'publish',
    NONE: 'none',
    VALIDATE: 'validate',
    EDIT_CLIENT_WISE: 'editClientWise',
    DOWNLOAD: 'download',
}

export const USER_RIGHTS_CONTENT_LABEL = {
    [USER_RIGHTS.EDIT]: 'Edit (Org Level)',
    [USER_RIGHTS.EDIT_CLIENT_WISE]: 'Edit (Client Level)',
}

export const CONTENT_SECTION_KEYS = {
    GLORIFIRE: 'glorifire',
    FTRE: 'ftre',
    AITS: 'aits',
    NATIONAL_LEVEL_TEST: 'nationalLevel'
 }

export const CONTENT_SECTION_TYPES = [
    {
        title: 'Glorifire',
        value: CONTENT_SECTION_KEYS.GLORIFIRE,
    },
    {
        title: 'Admission Test',
        value: CONTENT_SECTION_KEYS.FTRE,
    },
    {
        title: 'AITS',
        value: CONTENT_SECTION_KEYS.AITS,
    },
    {
        title: 'National Level Test',
        value: CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST,
    },
]

export const PERMISSION_TEST_CONTENT_TYPES = [PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS, PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS, PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS, PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS];
export const PERMISSION_QUESTION_CONTENT_TYPES = [PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION, PERMISSION_CONTENT_TYPES.FTRE_QUESTION, PERMISSION_CONTENT_TYPES.AITS_QUESTION, PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION];
export const CREATE_CONTENT_INDEXING = {
    [PERMISSION_CONTENT_TYPES.STUDY_MATERIAL]: 0,
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS]: 1,
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION]: 2,
    [PERMISSION_CONTENT_TYPES.FTRE_QUESTION]: 4,
    [PERMISSION_CONTENT_TYPES.AITS_QUESTION]: 5,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION]: 6,
    [PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS]: 7,
    [PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS]: 8,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS]: 9,
}

export const PERMISSION_TO_AUTHORING_CONTENT_TYPE_MAP = {
    [PERMISSION_CONTENT_TYPES.STUDY_MATERIAL]: AUTHORING_CONTENT_TYPES.STUDY_MATERIAL,
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION]: AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION,
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS]: AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS,
    [PERMISSION_CONTENT_TYPES.FTRE_QUESTION]: AUTHORING_CONTENT_TYPES.FTRE_QUESTION,
    [PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS]: AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS,
    [PERMISSION_CONTENT_TYPES.AITS_QUESTION]: AUTHORING_CONTENT_TYPES.AITS_QUESTION,
    [PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS]: AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION]: AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS]: AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS,
}

export const COMMON_CHECKBOXES = [USER_RIGHTS.NONE, USER_RIGHTS.VIEW, USER_RIGHTS.CREATE, USER_RIGHTS.VALIDATE, USER_RIGHTS.EDIT, USER_RIGHTS.EDIT_CLIENT_WISE];

export const MODULE_TO_BUCKET_MAP = {
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION]: CONTENT_SECTION_KEYS.GLORIFIRE,
    [PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS]: CONTENT_SECTION_KEYS.GLORIFIRE,
    [PERMISSION_CONTENT_TYPES.FTRE_QUESTION]: CONTENT_SECTION_KEYS.FTRE,
    [PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS]: CONTENT_SECTION_KEYS.FTRE,
    [PERMISSION_CONTENT_TYPES.AITS_QUESTION]: CONTENT_SECTION_KEYS.AITS,
    [PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS]: CONTENT_SECTION_KEYS.AITS,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION]: CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST,
    [PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS]: CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST,
}

export const MODULE_TO_TEST_MAP = {
    [CONTENT_SECTION_KEYS.GLORIFIRE]: AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS,
    [CONTENT_SECTION_KEYS.AITS]: AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS,
    [CONTENT_SECTION_KEYS.FTRE]: AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS,
    [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST]: AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS,
}

export const TEMPLATE_SETTING_FILTER_TYPES = {
    TEST_TYPE: 'testType',
    TEMPLATE_TYPE: 'templateType'
}

export const MODULE_TO_TEST_PERMISSION_MAP = {
    [CONTENT_SECTION_KEYS.GLORIFIRE]: PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS,
    [CONTENT_SECTION_KEYS.AITS]: PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS,
    [CONTENT_SECTION_KEYS.FTRE]: PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS,
    [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST]: PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS,
}

export const MODULE_TO_QUESTION_PERMISSION_MAP = {
    [CONTENT_SECTION_KEYS.GLORIFIRE]: PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION,
    [CONTENT_SECTION_KEYS.FTRE]: PERMISSION_CONTENT_TYPES.FTRE_QUESTION,
    [CONTENT_SECTION_KEYS.AITS]: PERMISSION_CONTENT_TYPES.AITS_QUESTION,
    [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST]: PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION,
}

export const TEST_ADDITIONAL_MODULES = [
    {
        DISPLAY_NAME: 'Basic Details',
        KEY: 'basicDetails'
    },
    {
        DISPLAY_NAME: 'Syllabus',
        KEY: 'syllabus'
    },
    {
        DISPLAY_NAME: 'Test Format',
        KEY: 'format'
    },
    {
        DISPLAY_NAME: 'Test Questions',
        KEY: 'questions'
    },
]

export const ADDITION_DRAFT_MODULE = {
    DISPLAY_NAME: 'Draft',
    KEY: 'draftViewEdit'
}

export const UTILS = {
    ADDITIONAL_SETTINGS: 'Additional Settings'
}

export const TEST_TEMPLATE_TYPES = {
    DEFAULT: 'default',
    CUSTOM: 'custom',
}

export const CONTENT_STATUS = {
    PUBLISH: 'PUBLISHED',
    DRAFT: 'DRAFT'
};

export const DATE_FORMAT = {
    DD_MMM_YYYY: 'dd-MMM-yyyy'
};

export const BOOLEAN_STATUS = {
    TRUE: 'true',
    FALSE: 'false'
};
export const CONTENT_SPECIAL_PURPOSES = {
    FTRE: 'ftre',
    RELEVANT_EXAMS: 'ftreRelevant',
    PREVIOUS_YEAR: 'ftrePreviousYear',
};

export const STATUS_CODES = {
    FORBIDDEN_ACCESS: 403,
    SUCCESS: 200,
}
export const USER_TYPE = {
    STUDENT: 'Glorifire'
}

export const DEFAULT_IDEAL_TIME = { value: 0, state: 1 };
export const REGEX_FOR_NUMBER = /^\d+$/;

export const ADDITIONAL_FUNCTIONALITY = {
    CONTENT_VALIDATION: 'content-validation'
};
export const TOTAL_QUESTION = 'totalQuestion';

export const ACADEMIC_YEAR_START = 2015;
export const MARCH_MONTH_INDEX = 2;
export const QUESTION_DEPENDENT_FILTERS_CATEGORY = ['difficulty', 'skill', 'benchmarking'];
export const FILTER_CATEGORIES = {
    CONTENT_TYPE: 'contentType',
    STATUS: 'status',
    PREVIOUS_YEAR_CONTENT: 'previousExams',
}
export const CONTENT_TYPE_FILTERS = {
    QUESTION: 'question',
}
export const PREVIOUS_CONTENT_START_YEAR = 2008;

export const CONTENT_TYPES_TO_HIDE_FROM_FILTER = ['formulas', 'videos', 'practiceSet']
export const EDP_REPORTS_STRING_CONSTANT = {
    QUESTION_CREATION_REPORT: 'Question Creation Report',
    QUESTION_ISSUES_REPORT: 'Question Issues Report'
}

export const DATA_TYPES = {
    BOOLEAN: 'boolean',
}

export const ACADEMIC_YEAR = {
    APRIL_MONTH_INDEX: 3,
    MARCH_MONTH_INDEX: 2,
    AY_END_DATE: 31,
    AY_START_DATE: 1,
}

export const PHASE_ACTIVITY_STATUS = {
    ACTIVATED: 'Activated',
    DEACTIVATED: 'Deactivated',
    ACTIVE_ICON_SRC: '/assets/svg/active-phase.svg',
    DEACTIVE_ICON_SRC: '/assets/svg/deactive-phase.svg',
}

export const TEST_TYPES_TEMPLATE = {
    DEFAULT: 'default',
    CUSTOM: 'custom',
    SELECTED_TEST_TYPE: 'Selected Test Type',
    TEST_TYPE: 'Test Type',
}
export const TEST_TEMPLATE_CONFIG = {
    GOAL: {
        name: 'courseId',
        checked: true,
        type: 'radio'
    },
    SECTION_LEVEL: [
        {
            name: 'Subject',
            key: 'subject',
        },
        {
            name: 'Unit',
            key: 'sub-subject',

        },
        {
            name: 'Chapter',
            key: 'chapter',

        },
        {
            name: 'Concept',
            key: 'concept',

        },
        {
            name: 'None',
            key: 'none',

        }
    ],
    MASTER_TEST_TYPE: [
        {
            name: 'Full Test',
            key: 'full',
        },
        {
            name: 'Unit Test',
            key: 'unit',
        },
        {
            name: 'Part Test',
            key: 'part',
        },
        {
            name: 'Half Course Test',
            key: 'combined',
        },
        {
            name: 'Concept Test',
            key: 'concept',
        },
        {
            name: 'Sample Test',
            key: 'sample',
        },
        {
            name: 'Chapter Test',
            key: 'chap',
        },
        {
            name: 'Phase Test',
            key: 'phase',
        }
    ],
    DURATION: [{
        name: 'Min',
        key: 'min'
    }],
    FIELDS: {
        GOAL: 'goal',
        SECTION_LEVEL: 'testSectionLevel',
        MASTER_TEST_TYPE: 'testTypeCode',
        DURATION: 'testDurationType'
    },
    DEFAULT_TIME: 180
};

export const TEST_TEMPLATE_ERROR_MESSAGE = {
    DURATION: 'Test Duration is required',
    GOAL: 'Template Goal is required',
};

export const KEY_CODE = {
    ENTER: 13,
}

export const VALIDATION_TYPE_CONSTANTS = [
    { label: 'Faculty Questions', value: 'Stakeholder'},
    { label: 'Student Questions', value: 'Glorifire'}
]